import React, { useEffect, useMemo, useRef, useState } from "react";
import { Row, Col, Modal, Form, Button, Dropdown } from "react-bootstrap";
// import '../../Assets/css/product_search.css'
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { bindFocus, bindPopper, usePopupState } from "material-ui-popup-state/hooks";
import {
    KlevuDomEvents,
    KlevuListenDomEvent,
    KlevuFetch,
    KlevuKMCSettings,
    KlevuLastSearches,
    KlevuResultEvent,
    KlevuTypeOfRecord,
    personalisation,
    search,
    suggestions,
    trendingProducts,
    KlevuConfig,
    searchCategory,
    searchCms,
} from "@klevu/core";
// import Product from "./Product";
import debounce from "lodash.debounce";
import {
    Grid,
    InputAdornment,
    Paper,
    Popper,
    TextField,
    Typography,
} from "@mui/material";
import { LoadingIndicator } from "./LoadingIndicator";
import axios from "axios";
import { Klevu_test_key, base_url, logout, postHeader, s3_img_url } from "../../Helper/request";
import { wishlistlength } from "../../Reducer/wishlistReducer";
import { productcount } from "../../Reducer/productReducer";
import { clickklevu } from "../../Reducer/homeReducer";


let clickManager;
// function useOutsideAlerter(ref) {
//     useEffect(() => {
//       /**
//        * Alert if clicked on outside of element
//        */
//       function handleClickOutside(event) {
//         if (ref.current && !ref.current.contains(event.target)) {
//           setShowpopup(false)
//         }
//       }
//       // Bind the event listener
//       document.addEventListener("mousedown", handleClickOutside);
//       return () => {
//         // Unbind the event listener on clean up
//         document.removeEventListener("mousedown", handleClickOutside);
//       };
//     }, [ref]);
//   }
function QuickSearchmain(props) {
    const wrapperRef = useRef(null);
    // useOutsideAlerter(wrapperRef);
    const [showPopup, setShowpopup] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userdata = useSelector(state => state.persistedReducer.home.user)
    const session_id = useSelector(state => state.persistedReducer.home.session_id)
    const [isSearchbox, isSetsearchbox] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [searchResultApi, setSearchResultApi] = useState("");
    const [products, setProducts] = useState([]);
    const [trendProducts, setTrendingProducts] = useState([]);
    const [lastSearches, setLastSearches] = useState(KlevuLastSearches.get());
    const [klevuSuggestions, setKlevuSuggestions] = useState([]);
    const [categories, setCategories] = useState([]);
    const [cms_klevu, setCms_klevu] = useState([]);
    const popupState = usePopupState({
        variant: "popper",
        popupId: "searchPopup",
        disableAutoFocus: true,
    });
    // var data = {
    //     recordQueries: [{
    //         id: "productSearch",
    //         typeOfRequest: "SEARCH",
    //         settings: {
    //             query: { term: 'short'},
    //             limit: 5,
    //             typeOfRecords: [KLEVU_PRODUCT]
    //         }
    //     }],
    //     context: { apiKeys: ["klevu-156925593843210765"] }
    // }
    useEffect(() => {
        //  clicked on outside of element
        function handleClickOutside(event) {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShowpopup(false)
            }
        }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [wrapperRef]);
    const [kmcSettings, setKmcSettings] = useState();
    useEffect(() => {
        KlevuConfig.init({
            url: "https://uscs33v2.ksearchnet.com/cs/v2/search",
            apiKey: Klevu_test_key,
            analytics: {
                apiKey: Klevu_test_key // your Klevu JS API Key
            }
        })

    }, []);
    useEffect(() => {
        setShowpopup(false);
        setProducts([]);
    }, [props.currentUrl]);

    const searchModifiers = props.enablePersonalisation ? [personalisation()] : [];
// console.log('personalisation',kmcSettings?.klevu_productsToShowInSlimLayout);
    const doSearch = async (term) => {
        if (term?.length < 3) {
            setProducts([]);
            setKlevuSuggestions([]);
            return;
        }
        const result = await KlevuFetch(
            search(
                term,
                {
                    id: "search",
                    limit: kmcSettings?.klevu_productsToShowInSlimLayout?.replace(/<\/?b>/g, ''),
                    typeOfRecords: [KlevuTypeOfRecord.Product],
                },
                ...searchModifiers,
                suggestions(term)
            ),
            search(term, {
                id: "categories",
                limit: 5,
                typeOfRecords: [KlevuTypeOfRecord.Category],
                groupBy: "name",
            }),
            search(term, {
                id: "cmsCompressed",
                limit: 5,
                typeOfRecords:["KLEVU_CMS"],
                groupBy: "name",
            }),
            suggestions(term, {
                id: "suggestions",
                limit: 10,
                typeOfRequest: "AUTO_SUGGESTIONS"
            })
        );
        const searchResult = result.queriesById("search");
        setSearchResultApi(searchResult.meta)
        clickManager = searchResult.getQueryParameters();

        setProducts(searchResult?.records ?? []);
        const searchSuggestions = result.suggestionsById("suggestions");
        setKlevuSuggestions(searchSuggestions.suggestions);
        setCms_klevu( result.queriesById("cmsCompressed")?.records.map((r) => r) ?? [])
        setCategories(
            result.queriesById("categories")?.records.map((r) => r) ?? []
        );
    };
    const fetchEmptySuggestions = async () => {
        setShowpopup(true)
        setLastSearches(KlevuLastSearches.get())
        handleLastSearchesUpdate();
        const res = await KlevuFetch(
            trendingProducts(
                {
                    limit: 6,
                    
                },
                ...searchModifiers
            )
        );
        setTrendingProducts(res.queriesById("trendingProducts")?.records ?? []);
    };

    // const onKeydown = (event) => {
    //     if (event.keyCode === 13) {
    //         const url = props.enablePersonalisation
    //             ? "/search?q="
    //             : `/searchnopersonalisation?q=`;
    //         props.onSearchClick?.(searchValue);
    //         popupState.close();
    //     }
    // };

    const onSearchChange = (event) => {

        setSearchValue(event.target.value);
        debouncedChangeHandler(event.target.value);
    };

    const debouncedChangeHandler = useMemo(() => debounce(doSearch, 300), []);

    const fetchKMCSettings = async () => {
        const settings = await KlevuKMCSettings();
        setKmcSettings(settings.root);
    };
    useEffect(() => {
        fetchKMCSettings();
        return () => {
            debouncedChangeHandler.cancel();
        };
    }, []);

    const handleLastSearchesUpdate = () => {
        setLastSearches(Array.from(KlevuLastSearches.get()).reverse());
    };

    useEffect(() => {
        const stop = KlevuListenDomEvent(
            KlevuDomEvents.LastSearchUpdate,
            handleLastSearchesUpdate
        );

        return () => {
            stop();
        };
    }, []);

    const focusParams = bindFocus(popupState);
    const params = {
        ...focusParams,
        onFocus: (event) => {
            focusParams.onFocus(event);
            setShowpopup(true)
            fetchEmptySuggestions();
        },
    };

    function hndlclicksend(p) {
        if (window.location.pathname?.includes("product-detail")) {
            dispatch(clickklevu(true));
        }
        setSearchValue("")
        setKlevuSuggestions([])
        setCategories([])
        setCms_klevu([])
        // setShowpopup(false)
        isSetsearchbox(!isSearchbox)
        setProducts([])

        // Product Tracking API by Click----
        var xhr = new XMLHttpRequest();
        xhr.withCredentials = false;
        xhr.addEventListener("readystatechange", function () {
            if (this.readyState === 4) {
                console.log(this.responseText);
            }
        });
        xhr.open("GET", `https://stats.ksearchnet.com/analytics/productTracking?klevu_apiKey=${Klevu_test_key}&klevu_keywords=${searchValue}&klevu_type=clicked&klevu_productId=${p.id}&klevu_productGroupId=${p.itemGroupId}&klevu_productVariantId=${p.id}&klevu_productName=${p.name}&klevu_productUrl=${p.url}`);
        xhr.send();

        // Product Tracking API by search value-----
        var requestOptions = {
            method: 'GET',
            redirect: 'follow'
        };
        fetch(`https://stats.ksearchnet.com/analytics/n-search/search?klevu_apiKey=${searchResultApi.apiKey}&klevu_term=${searchResultApi.searchedTerm}&klevu_totalResults=${searchResultApi.totalResultsFound}&klevu_typeOfQuery=${searchResultApi.typeOfSearch}`, requestOptions)
            .then(response => response.text())
            .then(result => console.log(result))
            .catch(error => console.log('error', error));
        setShowpopup(false);
    }
    // const add_to_wishlist = async (group_id, product_id, index) => {
    //     const data = {
    //         user_id: userdata?.user_id ? userdata?.user_id : "",
    //         session_id,
    //         product_id,
    //         group_id,
    //         token: userdata?.token ? userdata?.token : "",
    //     };
    //     await axios
    //         .post(base_url + "/product/add_to_wishlist", data, {
    //             headers: postHeader,
    //         })
    //         .then(async (res) => {
    //             if (res.data.status == 1) {
    //                 dispatch(wishlistlength(res.data.data.count));
    //                 // const data1 = await product?.productlist?.map((obj, ind) =>
    //                 //   index == ind
    //                 //     ? Object.assign({}, obj, { is_wishlist: res.data.data.wishlist_id })
    //                 //     : obj
    //                 // );
    //                 // dispatch(productlistdata(data1));
    //             } else if (res.data.status == 2) {
    //                 logout();
    //             } else {
    //                 dispatch(productcount(0));
    //             }
    //         })
    //         .catch((error) => {
    //             console.log(error);
    //         });
    // };
    const handle_KlavuSearch_Clear = (event) => {

        setSearchValue("");
        setShowpopup(true)
        setProducts([])
        debouncedChangeHandler(event.target.value);
    };
    return (
        <>
            <input aria-label="Search"
                className={
                    isSearchbox
                        ? "search_box_head"
                        : "d-none search_box_head"
                }
                type="text"
                id="my-search"
                // value={search}
                // placeholder="Search here"
                // onChange={(e)=> setSearch(e.target.value)}
                onKeyDown={(e) => {
                    if (e.keyCode === 13) {
                        if (searchValue.length > 0) {
                            setKlevuSuggestions([])
                            navigate('/searchlist/' + searchValue);
                        }
                        setShowpopup(false);
                        isSetsearchbox(!isSearchbox);
                        setSearchValue("");
                        setProducts([])
                        // window.woopra.track("search", {
                        //     term: searchValue,
                        //   });
                    }
                }}

                onInputCapture={() => setShowpopup(true)}
                autoComplete="off"
                label={props.label}
                value={searchValue}
                variant="filled"
                size="small"
                // onKeyDown={onKeydown}
                onChange={onSearchChange}
                onFocus={fetchEmptySuggestions}
                placeholder="Search for products"
                inputProps={{
                    autoComplete: "off",
                    form: {
                        autocomplete: "off",
                    },
                }}
            
                {...params}
            />
               {isSearchbox && searchValue?.length ?
<div className="klavu_search_clear">
<span onClick={(e) => handle_KlavuSearch_Clear(e)}>x</span>
</div>:""}


            {/* klevo code popup */}

            {showPopup === true ?
                kmcSettings?.klevu_layoutType === 'slim' ?
                    <div className="klevuLanding klevo_popup_modal_slim klevo_popup_modal" ref={wrapperRef} aria-hidden={popupState ? "true" : 'false'}  >
                        <div className="tranding_search_heading" ><span className="klevo_close" onClick={() => setShowpopup(false)}>x</span></div>
                        <Row>
                            <Col sm={12} md={12} >
                                <div className="klevo_categories_slim" >
                                    {klevuSuggestions?.length > 0 ? (
                                        <React.Fragment>
                                            <h6 className="tranding_search_heading">Suggestions</h6>
                                            <ul>
                                                {klevuSuggestions?.map((s, i) => (
                                                    <li
                                                        key={i}
                                                        dangerouslySetInnerHTML={{ __html: s.suggest }}
                                                        onClick={() => {
                                                            navigate(`/searchlist/${s.suggest.replace(/<\/?b>/g, '')}`)
                                                            // window.open(s.url, "_blank");
                                                            setSearchValue("")
                                                            setProducts([])
                                                            setKlevuSuggestions([])
                                                            setCategories([])
                                                            setCms_klevu([])
                                                            setShowpopup(false)
                                                        }}
                                                    ></li>
                                                ))}
                                            </ul>
                                        </React.Fragment>
                                    ) : (
                                        <React.Fragment>
                                            {kmcSettings &&
                                                kmcSettings?.klevu_webstorePopularTerms?.length > 0 && (
                                                    <React.Fragment>
                                                        <h6 className="tranding_search_heading">Popular searches</h6>
                                                        <ul>
                                                            {kmcSettings?.klevu_webstorePopularTerms?.map((s, i) => (
                                                                <li key={i} style={{ padding: 0 }}
                                                                    onClick={() => {
                                                                        navigate(`/productlist/${s}`)
                                                                        // window.open(s.url, "_blank");
                                                                        setShowpopup(false)
                                                                    }}
                                                                >
                                                                    {s}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </React.Fragment>
                                                )}
                                        </React.Fragment>
                                    )}
                                    
                                    {lastSearches?.length > 0 ? (
                                        <React.Fragment>
                                            <h6 className="tranding_search_heading">Last Searches</h6>
                                            <ul
                                                style={{ margin: 0, listStyleType: "none", padding: "12px" }}
                                            >
                                                {lastSearches?.map((s, i) => (
                                                    <li key={i} style={{ padding: 0 }}>
                                                        {s.term}
                                                    </li>
                                                ))}
                                            </ul>
                                        </React.Fragment>
                                    ) : null}
                                    {categories?.length > 0 ? (
                                        <React.Fragment>
                                            <h6 className="tranding_search_heading">Found categories</h6>
                                            <ul
                                                style={{ margin: 0, listStyleType: "none", padding: "12px" }}
                                            >
                                                {categories?.map((s, i) => (
                                                    <li key={i} style={{ padding: 0 }}
                                                        onClick={() => {
                                                            navigate(`/productlist/${s.slug}`)
                                                            // window.open(s.url, "_blank");
                                                            setSearchValue("")
                                                            setProducts([])
                                                            setKlevuSuggestions([])
                                                            setCategories([])
                                                            setCms_klevu([])
                                                            setShowpopup(false)
                                                        }}
                                                    >
                                                        {s.name}
                                                    </li>
                                                ))}
                                            </ul>
                                        </React.Fragment>
                                    ) : null}
                                    {cms_klevu.length > 0 ? <React.Fragment>
                                        <h6 className="tranding_search_heading">Pages</h6>
                                            <ul>
                                                {cms_klevu?.map((s, i) => (
                                                    <li key={i} style={{ padding: 0 }}
                                                        onClick={() => {
                                                            navigate(`${s.slug}`)
                                                            // window.open(s.url, "_blank");
                                                            setSearchValue("")
                                                            setProducts([])
                                                            setKlevuSuggestions([])
                                                            setCategories([])
                                                            setCms_klevu([])
                                                            setShowpopup(false)
                                                        }}
                                                    >
                                                        {s.name}
                                                    </li>
                                                ))}
                                            </ul>
                                    </React.Fragment>: null}
                                </div>

                                {products?.length > 0 ? (
                                    <>
                                        <h5 className="tranding_search_heading">Search results</h5>
                                        <div className="grid_1">
                                            <Row>
                                                {products?.map((p, i) => (
                                                    <Col sm={12} md={12} lg={12} className="mb-2">
                                                        <div className=" klevu-recs klevuProduct klevuProductClick kuTrackRecentView" klevu-data-id={p.id}>
                                                            {/* <div className="pro_wishlist_icon" >
                                                     <img src={s3_img_url + 'heart.svg'} onClick={() => add_to_wishlist(p?.itemGroupId, p?.id)} alt="wishlist" />
                                                 </div> */}{console.log('p?.itemGroupId',p)
                                                 }
                                                            <Link
                                                                 to={p?.isCustomOptionsAvailable == "Yes" ? "/custom-product-detail/" + p?.itemGroupId + "/" + p?.slug : "/product-detail/"  + p?.itemGroupId + "/" + p?.slug}
                                                                onClick={() => hndlclicksend(p)}
                                                                id="klevu-id"
                                                            >
                                                                <div className="klevuProductClick_1_slim">

                                                                    <div className="container_product_imgg">
                                                                        {!p.imageUrl.length == "" ?
                                                                            <img src={p.imageUrl} width="100" className="pro_imgg" alt={p.name} />
                                                                            : <img src={s3_img_url + 'home/placeholder_demi_img_KL.jpg'} width="100" className="pro_imgg" alt={p.name} />}
                                                                    </div>
                                                                    <div>
                                                                    <h4 variant="body2" className="title">{p.name}</h4>
                                                                    <h5 variant="h6" className="price">
                                                                        {new Intl.NumberFormat(undefined, {
                                                                            style: "currency",
                                                                            currency: p.currency,
                                                                        }).format(parseFloat(p.salePrice))}
                                                                    </h5>
                                                                    </div>
                                                                </div>
                                                            </Link>

                                                        </div>
                                                    </Col>

                                                ))}
                                            </Row>
                                        </div>

                                    </>
                                    // <>
                                    //     <h5 className="tranding_search_heading">Search results</h5>
                                    //     <div className="grid_1">
                                    //         <Row>
                                    //             {products?.map((p, i) => (
                                    //                 <Col sm={6} md={4} lg={4} >
                                    //                     <div className="klevuProduct klevuProductClick kuTrackRecentView" data-id={p.id}
                                    //                         onClick={() => {
                                    //                             navigate("/product-detail/" + p?.itemGroupId + "/" + p?.slug)
                                    //                             hndlclicksend(p);
                                    //                         }}
                                    //                     >
                                    //                         {/* <div className="pro_wishlist_icon" >
                                    //                             <img src={s3_img_url + 'heart.svg'} onClick={() => add_to_wishlist(p?.itemGroupId, p?.id)} alt="wishlist" />
                                    //                         </div> */}
                                    //                         <Link
                                    //                             // to={"/product-detail/" + p?.itemGroupId + "/" + p?.slug}
                                    //                             id="klevu-id"
                                    //                         >
                                    //                             <div className="klevuProductClick_1">

                                    //                                 <div className="container_product_imgg">
                                    //                                     {!p.imageUrl.length == "" ?
                                    //                                         <img src={p.imageUrl} width="100" className="pro_imgg" />
                                    //                                         : <img src={s3_img_url + 'home/placeholder_demi_img_KL.jpg'} width="100" className="pro_imgg" alt={p.name} />}
                                    //                                 </div>
                                    //                                 <h4 variant="body2" className="title">{p.name}</h4>
                                    //                                 <h5 variant="h6" className="price">
                                    //                                     {new Intl.NumberFormat(undefined, {
                                    //                                         style: "currency",
                                    //                                         currency: p.currency,
                                    //                                     }).format(parseFloat(p.salePrice))}
                                    //                                 </h5>
                                    //                             </div>
                                    //                         </Link>

                                    //                     </div>
                                    //                 </Col>

                                    //             ))}
                                    //         </Row>
                                    //     </div>

                                    // </>
                                ) : trendProducts?.length > 0 ? (
                                    <>
                                        <h5 className="tranding_search_heading">Trending products  </h5>
                                        <div className="grid_1">
                                            <div>
                                                {trendProducts?.map((p, i) => (
                                                    <Col sm={12} md={12} lg={12}>
                                                        <div className="klevuProduct klevuProductClick kuTrackRecentView" hideAddToCart key={i} data-id={p.id}  >
                                                            {/* <div className="pro_wishlist_icon" >
                                                        <img src={s3_img_url + 'heart.svg'} onClick={() => add_to_wishlist(p?.itemGroupId, p?.id)} alt="wishlist" />
                                                    </div>  */}{console.log('p?.itemGroupId',p)
                                                 }
                                                            <Link
                                                                  to={p?.isCustomOptionsAvailable == "Yes" ? "/custom-product-detail/" + p?.itemGroupId + "/" + p?.slug : "/product-detail/"  + p?.itemGroupId + "/" + p?.slug}
                                                                onClick={(event) => {
                                                                    if (window.location.pathname?.includes("product-detail")) {
                                                                        dispatch(clickklevu(true));
                                                                    }
                                                                    if (props.onClick) {
                                                                        props.onClick(event);
                                                                    }
                                                                    setSearchValue("")
                                                                    setKlevuSuggestions([])
                                                                    setCategories([])
                                                                    setCms_klevu([])
                                                                    props.onProductClick?.(p);
                                                                    setShowpopup(false);
                                                                    // popupState.close();
                                                                    isSetsearchbox(!isSearchbox)
                                                                    return false;
                                                                }}
                                                            >
                                                                <div className="klevuProductClick_1_slim">
                                                                    <div className="container_product_imgg">
                                                                        {!p.imageUrl.length == "" ? <img src={p.imageUrl} width="100" className="pro_imgg" alt="product_img" /> :
                                                                            <img src={s3_img_url + 'home/placeholder_demi_img_KL.jpg'} width="100" className="pro_imgg" alt={p.name} />}
                                                                    </div>

                                                                    <div>
                                                                    <h4 variant="body2" className="title">
                                                                        {p.name}
                                                                    </h4>
                                                                    <h5 variant="h6" className="price">
                                                                        {new Intl.NumberFormat(undefined, {
                                                                            style: "currency",
                                                                            currency: p.currency,
                                                                        }).format(parseFloat(p.salePrice))}
                                                                    </h5>
                                                                    </div>

                                                                </div></Link>
                                                        </div>
                                                    </Col>
                                                ))}
                                            </div>

                                            {/* <Row>
                                        {trendProducts?.map((p, i) => (

                                            <Col sm={6} md={4} lg={4}
                                                onClick={() => {
                                                    
                                                    navigate("/product-detail/" + p?.itemGroupId + "/" + p?.slug)
                                                }}
                                            >
                                                <Link
                                                    to={"/product-detail/" + p?.itemGroupId + "/" + p?.slug}
                                                >
                                                    <div onClick={(event) => {
                                                        setShowpopup(false);
                                                        // navigate("/product-detail/" + p?.itemGroupId + "/" + p?.slug)
                                                        if (window.location.pathname?.includes("product-detail")) {
                                                            dispatch(clickklevu(true));
                                                        }
                                                        if (props.onClick) {
                                                            props.onClick(event);
                                                        }
                                                        setSearchValue("")
                                                        // props.onProductClick?.(p);
                                                        isSetsearchbox(!isSearchbox)
                                                        return false;
                                                    }}
                                                        className="klevuProduct klevuProductClick kuTrackRecentView" hideAddToCart key={i} data-id={p.id}  >
                                                        {/* <div className="pro_wishlist_icon" >
                                                        <img src={s3_img_url + 'heart.svg'} onClick={() => add_to_wishlist(p?.itemGroupId, p?.id)} alt="wishlist" />
                                                    </div>  */}
                                            {/* <Link
                                                    // to={"/product-detail/" + p?.itemGroupId + "/" + p?.slug}
                                                    > */}
                                            {/* <div className="klevuProductClick_1">
                                                            <div className="container_product_imgg">
                                                                {!p.imageUrl.length == "" ? <img src={p.imageUrl} width="100" className="pro_imgg" alt="product_img" /> :
                                                                    <img src={s3_img_url + 'home/placeholder_demi_img_KL.jpg'} width="100" className="pro_imgg" alt={p.name} />}
                                                            </div>

                                                            <h4 variant="body2" className="title">
                                                                {p.name}
                                                            </h4>
                                                            <h5 variant="h6" className="price">
                                                                {new Intl.NumberFormat(undefined, {
                                                                    style: "currency",
                                                                    currency: p.currency,
                                                                }).format(parseFloat(p.salePrice))}
                                                            </h5>

                                                        </div> */}
                                            {/* </Link> */}
                                            {/* </div> */}
                                            {/* </Link> </Col> */}

                                            {/* ))} */}
                                            {/* </Row> */}
                                        </div>

                                    </>
                                ) : (
                                    <LoadingIndicator />
                                )}

                            </Col>
                        </Row>
                    </div>
                    :
                    kmcSettings?.klevu_layoutType == 'basic' ?
                        <div className="klevuLanding klevo_popup_modal klevo_popup_modal_basic" ref={wrapperRef} aria-hidden={popupState ? "true" : 'false'}  >
                            <div className="tranding_search_heading" ><span className="klevo_close" onClick={() => setShowpopup(false)}>x</span></div>
                            <Row>
                                <Col xs={12} md={3} lg={3} >
                                    <div className="klevo_categories" >
                                        {klevuSuggestions?.length > 0 ? (
                                            <React.Fragment>
                                                <h6 className="tranding_search_heading">Suggestions</h6>
                                                <ul>
                                                    {klevuSuggestions?.map((s, i) => (
                                                        <li
                                                            key={i}
                                                            dangerouslySetInnerHTML={{ __html: s.suggest }}
                                                            onClick={() => {
                                                                navigate(`/searchlist/${s.suggest.replace(/<\/?b>/g, '')}`)
                                                                // window.open(s.url, "_blank");
                                                                setSearchValue("")
                                                                setProducts([])
                                                                setKlevuSuggestions([])
                                                                setCategories([])
                                                                setCms_klevu([])
                                                                setShowpopup(false)
                                                            }}
                                                        ></li>
                                                    ))}
                                                </ul>
                                            </React.Fragment>
                                        ) : (
                                            <React.Fragment>
                                                {kmcSettings &&
                                                    kmcSettings?.klevu_webstorePopularTerms?.length > 0 && (
                                                        <React.Fragment>
                                                            <h6 className="tranding_search_heading">Popular searches</h6>
                                                            <ul>
                                                                {kmcSettings?.klevu_webstorePopularTerms?.map((s, i) => (
                                                                    <li key={i} style={{ padding: 0 }}
                                                                        onClick={() => {
                                                                            navigate(`/productlist/${s}`)
                                                                            // window.open(s.url, "_blank");
                                                                            setShowpopup(false)
                                                                        }}
                                                                    >
                                                                        {s}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </React.Fragment>
                                                    )}
                                            </React.Fragment>
                                        )}
                                        
                                        {lastSearches?.length > 0 ? (
                                            <React.Fragment>
                                                <h6 className="tranding_search_heading">Last Searches</h6>
                                                <ul
                                                    style={{ margin: 0, listStyleType: "none", padding: "12px" }}
                                                >
                                                    {lastSearches?.map((s, i) => (
                                                        <li key={i} style={{ padding: 0 }}>
                                                            {s.term}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </React.Fragment>
                                        ) : null}
                                        {categories?.length > 0 ? (
                                            <React.Fragment>
                                                <h6 className="tranding_search_heading">Found categories</h6>
                                                <ul
                                                    style={{ margin: 0, listStyleType: "none"}}
                                                >
                                                    {categories?.map((s, i) => (
                                                        <li key={i} style={{ padding: 0 }}
                                                            onClick={() => {
                                                                navigate(`/productlist/${s.slug}`)
                                                                // window.open(s.url, "_blank");
                                                                setSearchValue("")
                                                                setProducts([])
                                                                setKlevuSuggestions([])
                                                                setCategories([])
                                                                setCms_klevu([])
                                                                setShowpopup(false)
                                                            }}
                                                        >
                                                            {s.name}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </React.Fragment>
                                        ) : null}
                                       {cms_klevu.length>0 ? <React.Fragment>
                                           <h6 className="tranding_search_heading">Pages</h6>
                                            <ul>
                                           {cms_klevu?.map((s, i) => (
                                                   <li key={i} style={{ padding: 0 }}
                                                   onClick={() => {
                                                    navigate(`${s.slug}`)
                                                    // window.open(s.url, "_blank");
                                                    setSearchValue("")
                                                    setProducts([])
                                                    setKlevuSuggestions([])
                                                    setCategories([])
                                                    setCms_klevu([])
                                                    setShowpopup(false)
                                                   }}
                                               >
                                                   {s.name}
                                               </li>
                                                ))}
                                            </ul>
                                        </React.Fragment> : null}
                                    </div>

                                </Col>
                                <Col sm={12} md={9} lg={9} >

                                    {products?.length > 0 ? (
                                        <>
                                            <h5 className="tranding_search_heading">Search results</h5>
                                            <div className="grid_1">
                                                <Row>
                                                    {products?.map((p, i) => (
                                                        <Col sm={6} md={4} lg={4} >
                                                            <div className=" klevu-recs klevuProduct klevuProductClick kuTrackRecentView" klevu-data-id={p.id}>
                                                                {/* <div className="pro_wishlist_icon" >
                                                     <img src={s3_img_url + 'heart.svg'} onClick={() => add_to_wishlist(p?.itemGroupId, p?.id)} alt="wishlist" />
                                                 </div> */}{console.log('p?.itemGroupId',p?.isCustomOptionsAvailable)
                                                 }
                                                                <Link
                                                                     to={p?.isCustomOptionsAvailable == "Yes" ? "/custom-product-detail/" + p?.itemGroupId + "/" + p?.slug : "/product-detail/"  + p?.itemGroupId + "/" + p?.slug}
                                                                    onClick={() => hndlclicksend(p)}
                                                                    id="klevu-id"
                                                                >
                                                                    <div className="klevuProductClick_1">

                                                                        <div className="container_product_imgg">
                                                                            {!p.imageUrl.length == "" ?
                                                                                <img alt={p.name} src={p.imageUrl} width="100" className="pro_imgg" />
                                                                                : <img src={s3_img_url + 'home/placeholder_demi_img_KL.jpg'} width="100" className="pro_imgg" alt={p.name} />}
                                                                        </div>
                                                                        <h4 variant="body2" className="title">{p.name}</h4>
                                                                        <h5 variant="h6" className="price">
                                                                            {new Intl.NumberFormat(undefined, {
                                                                                style: "currency",
                                                                                currency: p.currency,
                                                                            }).format(parseFloat(p.salePrice))}
                                                                        </h5>
                                                                    </div>
                                                                </Link>

                                                            </div>
                                                        </Col>

                                                    ))}
                                                </Row>
                                            </div>

                                        </>
                                        // <>
                                        //     <h5 className="tranding_search_heading">Search results</h5>
                                        //     <div className="grid_1">
                                        //         <Row>
                                        //             {products?.map((p, i) => (
                                        //                 <Col sm={6} md={4} lg={4} >
                                        //                     <div className="klevuProduct klevuProductClick kuTrackRecentView" data-id={p.id}
                                        //                         onClick={() => {
                                        //                             navigate("/product-detail/" + p?.itemGroupId + "/" + p?.slug)
                                        //                             hndlclicksend(p);
                                        //                         }}
                                        //                     >
                                        //                         {/* <div className="pro_wishlist_icon" >
                                        //                             <img src={s3_img_url + 'heart.svg'} onClick={() => add_to_wishlist(p?.itemGroupId, p?.id)} alt="wishlist" />
                                        //                         </div> */}
                                        //                         <Link
                                        //                             // to={"/product-detail/" + p?.itemGroupId + "/" + p?.slug}
                                        //                             id="klevu-id"
                                        //                         >
                                        //                             <div className="klevuProductClick_1">

                                        //                                 <div className="container_product_imgg">
                                        //                                     {!p.imageUrl.length == "" ?
                                        //                                         <img src={p.imageUrl} width="100" className="pro_imgg" />
                                        //                                         : <img src={s3_img_url + 'home/placeholder_demi_img_KL.jpg'} width="100" className="pro_imgg" alt={p.name} />}
                                        //                                 </div>
                                        //                                 <h4 variant="body2" className="title">{p.name}</h4>
                                        //                                 <h5 variant="h6" className="price">
                                        //                                     {new Intl.NumberFormat(undefined, {
                                        //                                         style: "currency",
                                        //                                         currency: p.currency,
                                        //                                     }).format(parseFloat(p.salePrice))}
                                        //                                 </h5>
                                        //                             </div>
                                        //                         </Link>

                                        //                     </div>
                                        //                 </Col>

                                        //             ))}
                                        //         </Row>
                                        //     </div>

                                        // </>
                                    ) : trendProducts?.length > 0 ? (
                                        <>
                                            <h5 className="tranding_search_heading">Trending products  </h5>
                                            <div className="grid_1">
                                                <Row>
                                                    {trendProducts?.map((p, i) => (
                                                        <Col sm={6} md={4} lg={4}>
                                                            <div className="klevuProduct klevuProductClick kuTrackRecentView" hideAddToCart key={i} data-id={p.id}  >
                                                                {/* <div className="pro_wishlist_icon" >
                                                        <img src={s3_img_url + 'heart.svg'} onClick={() => add_to_wishlist(p?.itemGroupId, p?.id)} alt="wishlist" />
                                                    </div>  */}
                                                                <Link
                                                                      to={p?.isCustomOptionsAvailable == "Yes" ? "/custom-product-detail/" + p?.itemGroupId + "/" + p?.slug : "/product-detail/"  + p?.itemGroupId + "/" + p?.slug}
                                                                    onClick={(event) => {
                                                                        if (window.location.pathname?.includes("product-detail")) {
                                                                            dispatch(clickklevu(true));
                                                                        }
                                                                        if (props.onClick) {
                                                                            props.onClick(event);
                                                                        }
                                                                        setSearchValue("")
                                                                        setProducts([])
                                                                        setKlevuSuggestions([])
                                                                        setCategories([])
                                                                        setCms_klevu([])
                                                                        props.onProductClick?.(p);
                                                                        setShowpopup(false);
                                                                        // popupState.close();
                                                                        isSetsearchbox(!isSearchbox)
                                                                        return false;
                                                                    }}
                                                                >
                                                                    <div className="klevuProductClick_1">
                                                                        <div className="container_product_imgg">
                                                                            {!p.imageUrl.length == "" ? <img src={p.imageUrl} width="100" className="pro_imgg" alt="product_img" /> :
                                                                                <img src={s3_img_url + 'home/placeholder_demi_img_KL.jpg'} width="100" className="pro_imgg" alt={p.name} />}
                                                                        </div>

                                                                        <h4 variant="body2" className="title">
                                                                            {p.name}
                                                                        </h4>
                                                                        <h5 variant="h6" className="price">
                                                                            {new Intl.NumberFormat(undefined, {
                                                                                style: "currency",
                                                                                currency: p.currency,
                                                                            }).format(parseFloat(p.salePrice))}
                                                                        </h5>

                                                                    </div></Link>
                                                            </div>
                                                        </Col>
                                                    ))}
                                                </Row>

                                                {/* <Row>
                                        {trendProducts?.map((p, i) => (

                                            <Col sm={6} md={4} lg={4}
                                                onClick={() => {
                                                    
                                                    navigate("/product-detail/" + p?.itemGroupId + "/" + p?.slug)
                                                }}
                                            >
                                                <Link
                                                    to={"/product-detail/" + p?.itemGroupId + "/" + p?.slug}
                                                >
                                                    <div onClick={(event) => {
                                                        setShowpopup(false);
                                                        // navigate("/product-detail/" + p?.itemGroupId + "/" + p?.slug)
                                                        if (window.location.pathname?.includes("product-detail")) {
                                                            dispatch(clickklevu(true));
                                                        }
                                                        if (props.onClick) {
                                                            props.onClick(event);
                                                        }
                                                        setSearchValue("")
                                                        // props.onProductClick?.(p);
                                                        isSetsearchbox(!isSearchbox)
                                                        return false;
                                                    }}
                                                        className="klevuProduct klevuProductClick kuTrackRecentView" hideAddToCart key={i} data-id={p.id}  >
                                                        {/* <div className="pro_wishlist_icon" >
                                                        <img src={s3_img_url + 'heart.svg'} onClick={() => add_to_wishlist(p?.itemGroupId, p?.id)} alt="wishlist" />
                                                    </div>  */}
                                                {/* <Link
                                                    // to={"/product-detail/" + p?.itemGroupId + "/" + p?.slug}
                                                    > */}
                                                {/* <div className="klevuProductClick_1">
                                                            <div className="container_product_imgg">
                                                                {!p.imageUrl.length == "" ? <img src={p.imageUrl} width="100" className="pro_imgg" alt="product_img" /> :
                                                                    <img src={s3_img_url + 'home/placeholder_demi_img_KL.jpg'} width="100" className="pro_imgg" alt={p.name} />}
                                                            </div>

                                                            <h4 variant="body2" className="title">
                                                                {p.name}
                                                            </h4>
                                                            <h5 variant="h6" className="price">
                                                                {new Intl.NumberFormat(undefined, {
                                                                    style: "currency",
                                                                    currency: p.currency,
                                                                }).format(parseFloat(p.salePrice))}
                                                            </h5>

                                                        </div> */}
                                                {/* </Link> */}
                                                {/* </div> */}
                                                {/* </Link> </Col> */}

                                                {/* ))} */}
                                                {/* </Row> */}
                                            </div>

                                        </>
                                    ) : (
                                        <LoadingIndicator />
                                    )}

                                </Col>
                            </Row>



                        </div> : ''

                : ' '}


            {/* klevo_popup_modal_overlay  */}
            {/* klevo code end */}

            {/* <Link to="#" aria-label="Search"> */}
                <span
                    className="header-icon search"
                    onClick={() => { isSetsearchbox(!isSearchbox); setShowpopup(false); }}
                ></span>
            {/* </Link> */}

        </>
    )
}

export default QuickSearchmain


// By om (friday)

// for live : replace QuickSearchmain.js page and product_search.css page'